
import React from 'react';
import { Route, Navigate, Routes } from 'react-router-dom';
import Index from '@/pages/Index';
import SaasLanding from '@/pages/SaasLanding';
import Login from '@/pages/Login';
import SignupPage from '@/pages/SignupPage';
import PricingPage from '@/pages/PricingPage';
import SaasSignup from '@/pages/SaasSignup';
import SaasLogin from '@/pages/SaasLogin';
import BusinessCustomLanding from '@/pages/BusinessCustomLanding';
import CustomBusinessLanding from '@/pages/CustomBusinessLanding';
import ResellerSaasLanding from '@/components/saas/landing/ResellerSaasLanding';
import BusinessResellerOrder from '@/pages/BusinessResellerOrder';
import HowItWorks from '@/pages/HowItWorks';
import BusinessSignup from '@/pages/BusinessSignup';
import BusinessAccountCreate from '@/pages/BusinessAccountCreate';
import BusinessOnboarding from '@/pages/BusinessOnboarding';
import SignupSuccess from '@/pages/SignupSuccess';
import FAQ from '@/pages/FAQ';
import PricingPlans from '@/pages/PricingPlans';

interface PublicRoutesProps {
  isLoggedIn: boolean;
}

const PublicRoutes: React.FC<PublicRoutesProps> = ({ isLoggedIn }) => {
  console.log('PublicRoutes rendering, isLoggedIn:', isLoggedIn);
  
  return (
    <Routes>
      <Route path="/" element={<Index />} />
      <Route path="/custom" element={<BusinessCustomLanding />} />
      <Route path="/business-custom-landing" element={<CustomBusinessLanding />} />
      <Route path="/saas" element={<SaasLanding />} />
      <Route path="/how-it-works" element={<HowItWorks />} />
      <Route path="/faq" element={<FAQ />} />
      <Route path="/saas-reseller" element={<ResellerSaasLanding />} />
      <Route path="/login" element={!isLoggedIn ? <Login /> : <Navigate to="/dashboard" />} />
      <Route path="/signup" element={!isLoggedIn ? <SignupPage /> : <Navigate to="/dashboard" />} />
      <Route path="/pricing" element={<PricingPage />} />
      <Route path="/pricing-plans" element={<PricingPlans />} />
      <Route path="/saas-signup" element={<SaasSignup />} />
      <Route path="/saas-login" element={<SaasLogin />} />
      <Route path="/business-reseller-order" element={<BusinessResellerOrder />} />
      <Route path="/business-signup" element={<BusinessSignup />} />
      <Route path="/business-account-create" element={<BusinessAccountCreate />} />
      <Route path="/business-onboarding" element={<BusinessOnboarding />} />
      <Route path="/signup-success" element={<SignupSuccess />} />
    </Routes>
  );
};

export default PublicRoutes;
